import React, { Component } from 'react';
// import Paragraph from './paragraph';
// import StudioTourSideInfo from './studioTourSideInfo';

class StudioTourAbout extends Component {
  render() {
    // const { paragraphs, additionalInfo } = this.props.studioTour;
    const { additionalInfo } = this.props.studioTour;

    return (
      <div className="bottomMargin-container">
        {/* Render heading of 1st para only. */}
        {/* {paragraphs[0] && <h2>{paragraphs[0].heading}</h2>} */}
        <h2>18th Annual Artist Studio Tour – 2025</h2>

        <div className="aboutCart-row">
          <div className="aboutCart-p">
            <p>
              We’re excited to announce that <strong>registration is now open for the 2025 Tahoe Art League Studio Tour (Aug 1–3, 2025)</strong> - one of the most vibrant and well-loved art events in the region!
            </p>
            <p>
              This is a fantastic opportunity to showcase your work, connect with art lovers, and be part of a supportive community of local creatives.
            </p>
            <p>
              <strong>Not a TAL member yet?</strong> No problem - you can purchase your membership <strong>at the same time as you register</strong> for the Studio Tour. It’s quick and easy to do online, and great value.
            </p>
            <p style={{textAlign:'center'}}>You can sign up here:<br/><a href="http://bit.ly/4iaekkC" target="_blank">Event and Membership Signup</a></p>
            <p>
              This year’s tour will be a fun and energetic three-day event, and we’d love to have you involved!
            </p>
            <p>
              And don’t forget:<br/>
              - use code <strong>EARLYBIRD</strong> through April to get 20% off registration!<br/>
              - you can forward this link to any other artists you think might be interested - if you or they don't have a space, we can help you find a space to show together :)
            </p>
            {/* <p> */}
              {/* Be sure to check out this years{' '}
              <a
                href="/assets/studioTourArtists2023.jpg"
                target="_blank"
                rel="noreferrer"
              >
                artists line up
              </a>
              .  */}
              {/* We look forward to seeing you at the Tahoe Art League Gallery:
              3062 Lake Tahoe Boulevard in beautiful South Lake Tahoe. */}
            {/* </p> */}
          </div>
          {/* <StudioTourSideInfo additionalInfo={additionalInfo} /> */}
        </div>
      </div>
    );
  }
}

export default StudioTourAbout;
